import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import DataExplorerHeader from '../../components/DataExplorerHeader'
import DataExplorerHeaderSmall from '../../components/DataExplorerHeaderSmall'
import DataExplorerIndex from '../DataExplorerIndex'
import DataExplorerCountries from '../DataExplorerCountries'
import DataExplorerCountry from '../DataExplorerCountry'
import DataExplorerTopics from '../DataExplorerTopics'
import DataExplorerTopic from '../DataExplorerTopic'
import DataExplorerTopicTFA from '../DataExplorerTopicTFA'
import DataExplorerSources from '../DataExplorerSources'
import { setDataByCountry, setDataByIndicator } from '../../state/actions'
import './index.css'


class DataExplorer extends React.PureComponent {

  render() {
    const { location } = this.props
    return (
      <div>
        {/* header */}
        <Switch key={location.key} location={location}>
          <Route path="/" exact component={DataExplorerHeader}/>
          <Route path="/countries" exact component={DataExplorerHeader}/>
          <Route path="/countries/:countryCode" exact component={DataExplorerHeaderSmall}/>
          <Route path="/topics" exact component={DataExplorerHeader}/>
          <Route path="/topics/:topic" exact component={DataExplorerHeaderSmall}/>
          <Route path="/tfa/:topic" exact component={DataExplorerHeaderSmall}/>
          <Route path="/sources" exact component={DataExplorerHeaderSmall}/>
        </Switch>

        {/* content */}
        <div className="cf ph5 pv3">
          <div className="h-container">
          <Switch key={location.key} location={location}>
            <Route path="/" exact component={DataExplorerIndex}/>
            <Route path="/countries" exact component={DataExplorerCountries}/>
            <Route path="/countries/:countryCode" exact component={DataExplorerCountry}/>
            <Route path="/topics" exact component={DataExplorerTopics}/>
            <Route path="/topics/:topic" exact component={DataExplorerTopic}/>
            <Route path="/tfa/:topic" exact component={DataExplorerTopicTFA}/>
            <Route path="/sources" exact component={DataExplorerSources}/>
          </Switch>
          </div>
        </div>
        
      </div>
    )
  }
}



export default withRouter(connect(null, { setDataByCountry, setDataByIndicator })(DataExplorer))



// WEBPACK FOOTER //
// ./src/pages/DataExplorer/index.js